export default __webpack_public_path__ + "static/media/notice_after_login.e17d0081.svg";